import * as Sentry from "@sentry/react";

// Tracking Events
import { trackEvent } from "@intercom/messenger-js-sdk";
// import ReactPixel from "react-facebook-pixel";
// import { trackAdsByRedux } from "../utm";
import { gaEvent } from "../trackEvents";

const isProduction = process.env.NODE_ENV === "production";

export const postUpgradeTrackingEvents = ({ plan, subscriptionId, listing }) => {
  // Google Analytics
  // sent by the back-end
  // gaEvent({
  //   category: "Upgrade",
  //   action: "Start Trial",
  //   label: getGALabelStartTrial(listing)
  // });

  gaEvent({
    category: "Upgrade",
    action: `Upgrade to ${plan.name} - ${plan.annual ? "Annual" : "Monthly"}`,
    label: getGALabelUpgrade(listing)
  });

  // trackAdsByRedux({
  //   from: "google",
  //   category: "Upgrade",
  //   action: "StartTrialUTM"
  // });

  // trackAdsByRedux({
  //   from: "google",
  //   category: "Upgrade",
  //   action: `Upgrade to ${plan.name} - ${plan.annual ? "Annual" : "Monthly"} UTM`
  // });

  // Facebook Pixel - conversion (StartTrial)
  // sent by the back-end
  // ReactPixel.trackCustom(`StartTrial${plan.name}`);
  // ReactPixel.trackCustom("Start Trial - Event", {
  //   value: 1.99,
  //   currency: "USD",
  //   predicted_ltv: 180.0
  // });

  // sent by the back-end
  // trackAdsByRedux({
  //   from: "facebook",
  //   action: `StartTrial${plan.name}UTM`
  // });

  // trackAdsByRedux({
  //   from: "facebook",
  //   action: "StartTrialUTM"
  // });

  // Intercom
  trackEvent(`Plan Updated to ${plan.name}`);

  // ShareASale
  triggerShareASale({ plan, subscriptionId });

  // Gravity AI Conversion Tracking
  const planValue = plan.price_plan || plan.price_cents / 100 || 0;
  triggerGravityConversion({
    orderId: subscriptionId,
    value: planValue,
    currency: "USD"
  });
};

const triggerShareASale = ({ plan, subscriptionId }) => {
  const { price_plan: pricePlan, price_cents: priceCents } = plan;
  const formattedPricePlan = pricePlan || priceCents / 100;
  try {
    if (plan !== undefined && subscriptionId) {
      let img = document.createElement("img");
      img.src = `https://www.shareasale.com/sale.cfm?tracking=${subscriptionId}&amount=${formattedPricePlan}&merchantID=99321&transtype=sale`;
      document.head.appendChild(img);

      let script = document.createElement("script");
      script.setAttribute("src", "https://www.dwin1.com/19038.js");
      document.head.appendChild(script);
    }
  } catch (err) {
    console.log(err);
  }
};

// sent by the back-end
// const getGALabelStartTrial = listing => {
//   // Users who created the account through our landing page
//   const isLandingPageDirectSignUp = localStorage.getItem("landing_page_signup");
//
//   if (isLandingPageDirectSignUp === "variant") {
//     return "Email Signup Variant Start Trial";
//   } else if (isLandingPageDirectSignUp === "control") {
//     return "Email Signup Control Start Trial";
//   } else if (isLandingPageDirectSignUp === "notIncluded") {
//     return "Email Signup Not Included Start Trial";
//   } else {
//     if (listing === undefined) {
//       return "";
//     } else if (listing.premium === true) {
//       return "Premium Start Trial";
//     } else if (listing.premium === false) {
//       return "Non-premium Start Trial";
//     }
//   }
// };

const getGALabelUpgrade = listing => {
  // Users who created the account through our landing page
  const isLandingPageDirectSignUp = localStorage.getItem("landing_page_signup");

  if (isLandingPageDirectSignUp === "variant") {
    return "Email Signup Variant Upgrade";
  } else if (isLandingPageDirectSignUp === "control") {
    return "Email Signup Control Upgrade";
  } else if (isLandingPageDirectSignUp === "notIncluded") {
    return "Email Signup Not Included Upgrade";
  } else {
    if (listing === undefined) {
      return "";
    } else if (listing.premium === true) {
      return "Premium Upgrade";
    } else if (listing.premium === false) {
      return "Non-premium Upgrade";
    }
  }
};

export const triggerPageViewCheckout = (data = undefined) => {
  window.gtag("event", "checkoutPageView", data);
};

// Gravity AI Conversion Tracking
export const triggerGravityConversion = ({ orderId, value = 0, currency = "USD" }) => {
  if (!isProduction) return;

  try {
    const existingScript = document.querySelector('script[src*="trygravity.ai/conversion.js"]');
    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement("script");
    script.src = "https://code.trygravity.ai/conversion.js";
    script.async = true;
    script.setAttribute("data-api-key", process.env.REACT_APP_GRAVITY_API_KEY);
    script.setAttribute("data-type", "purchase");
    script.setAttribute("data-value", value.toString());
    script.setAttribute("data-order-id", orderId || "");
    script.setAttribute("data-currency", currency);

    document.head.appendChild(script);
  } catch (err) {
    console.error("Error triggering Gravity conversion:", err);
    Sentry.captureException(err, { extra: { orderId, value, currency } });
  }
};
